import type {
  FraudFlagsCount,
  FraudFlagView,
  FraudUserReview,
  FraudReviewActionPayload,
} from '@klaro7/shared-types';

import api from '@/lib/api';

/** Segnalazioni antifrode multi-account — endpoint super-admin. */

export async function getFraudFlagsCount(): Promise<FraudFlagsCount> {
  const { data } = await api.get('/fraud/flags/count');
  return data.data as FraudFlagsCount;
}

export async function getFraudFlags(status = 'open'): Promise<FraudFlagView[]> {
  const { data } = await api.get('/fraud/flags', { params: { status } });
  return data.data as FraudFlagView[];
}

export async function getUserAbuseReview(userId: string): Promise<FraudUserReview> {
  const { data } = await api.get(`/fraud/users/${userId}/review`);
  return data.data as FraudUserReview;
}

export async function reviewFraudFlag(
  flagId: string,
  payload: FraudReviewActionPayload
): Promise<void> {
  await api.patch(`/fraud/flags/${flagId}`, payload);
}
